import React from 'react';
import { Field } from 'formik';
import * as yup from 'yup';

import { Flex } from 'shared/components/display';
import { StepFieldProps } from 'shared/components/forms/MultiStepForm/interfaces';
import ButtonGroupInput, { Option } from 'shared/components/molecules/ButtonGroupInput/ButtonGroupInput';
import { buttonGroupRequiredSchema } from 'shared/components/molecules/ButtonGroupInput/validation';
import TextInput from 'shared/components/TextInput';

import styles from './styles';
export const referralOtherOption = { value: 'other', label: 'Other' };
export const referralColleagueOption = { value: 'Colleague/friend', label: 'Colleague/friend' };
const options = [
  referralColleagueOption,
  { value: 'Facebook', label: 'Facebook/Instagram' },
  { value: 'Search engine (Google, Bing, etc)', label: 'Search engine (Google, Bing, etc)' },
  { value: 'TikTok', label: 'TikTok' },
  { value: 'Blog/publication', label: 'Blog/publication' },
  { value: 'Backstage', label: 'Backstage' },
  referralOtherOption,
];

export const ReferralOnboardingStepFields: React.FC<StepFieldProps<ReferralValues>> = ({ formikProps }) => {
  const showTextField =
    formikProps?.values.referral?.find((v) => referralColleagueOption.value === v.value)?.selected || false;

  return (
    <Flex css={styles} className="referral">
      <ButtonGroupInput
        name={REFERRAL_FIELDNAMES.REFERRAL}
        otherOptionFieldName={REFERRAL_FIELDNAMES.REFERRAL_OTHER}
        otherOptionValue={referralOtherOption.value}
        otherOptionPlaceholder="Please specify how you heard about us."
      />
      {showTextField && (
        <Field
          name={REFERRAL_FIELDNAMES.REFERRAL_OTHER}
          label="Colleague/Friend"
          component={TextInput}
          className="referral__other"
          maxLength={20}
          placeholder="Please provide the name of who referred you."
          dataCy="btn-group__other"
        />
      )}
    </Flex>
  );
};

export const REFERRAL_FIELDNAMES = {
  REFERRAL: 'referral',
  REFERRAL_OTHER: 'referralOther',
};

export const referralInitialValues: ReferralValues = {
  referral: options,
  referralOther: '',
};

export const referralSchema = yup.object({
  referral: buttonGroupRequiredSchema,
  referralOther: yup.string().when('referral', {
    is: (value: Option[]) => {
      const referralOption = value.find((op) => op.value === referralOtherOption.value);
      return referralOption?.selected;
    },
    then: yup.string().customRequiredString(),
  }),
});

export type ReferralValues = {
  referral: Option[];
  referralOther: string;
};
